import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import { loginOtp } from 'features/auth/api/request-login-otp';

const useLoginPassword = ({ formData, setFormData, setLoginOtp }) => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({
    email: '',
    password: '',
    error: '',
  });

  useEffect(() => {
    localStorage.removeItem('isWebView');
    localStorage.removeItem('sharedToken');
  }, []);

  const requestOtpMutation = useMutation((payload) => loginOtp(payload), {
    onSuccess: () => {
      setLoginOtp(true);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.errors?.[0]?.message ||
        error?.response?.data?.message ||
        error?.message ||
        t('server_error');
      setErrors({ error: message });
    },
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '', error: '' }));
  };

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = () => {
    if (requestOtpMutation.isLoading) return;

    setErrors({});

    const email = formData.email?.trim() || '';
    const password = formData.password?.trim() || '';
    const validationErrors = {};

    if (!email) {
      validationErrors.email = t('email_required');
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      validationErrors.email = t('email_invalid_format');
    }

    if (!password) {
      validationErrors.password = t('password_required');
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    requestOtpMutation.mutate(formData);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleLogin();
    }
  };

  const navigateToForgotPassword = () => {
    navigate('/forgot-password/send-reset-link');
  };

  return {
    showPassword,
    loading: requestOtpMutation.isLoading,
    errors,
    handleChange,
    handleTogglePassword,
    handleLogin,
    handleKeyDown,
    navigateToForgotPassword,
  };
};

export default useLoginPassword;
